
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0d70"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0d70"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9q0SL", function(module, exports) {

$parcel$export(module.exports, "Category", () => $40ee809f5cee2de7$export$3a8840c5b2ecf003);
class $40ee809f5cee2de7$export$3a8840c5b2ecf003 {
    constructor(boxId){
        this.boxId = boxId;
        this.children = [];
        this.categoryBox = document.querySelector(`#${boxId}`);
    }
    appendTodo(item) {
        if (item.elm) {
            item.currentGroup = this.boxId;
            this.children.push(item);
            this.refreshCategoryBox();
        } else throw Error("[Category.appendTodo] item.elm = null");
    }
    deleteTodo(itemUuid) {
        this.children = this.children.filter((child)=>child.uuid !== itemUuid);
        this.refreshCategoryBox();
    }
    refreshCategoryBox() {
        while(this.categoryBox.firstChild)this.categoryBox.removeChild(this.categoryBox.firstChild);
        this.children.forEach((child)=>{
            if (child.elm) this.categoryBox.appendChild(child.elm);
        });
    }
}

});


parcelRequire("9q0SL");

//# sourceMappingURL=index.dddbabfb.js.map
